/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import LocalitiesDemo from './LocalitiesDemo';
import Button from '../Button/Button';
import ButtonGroup from '../Button/ButtonGroup';
import LocalitiesAddressDemo from './LocalitiesAddressDemo';
import { tr } from '../utils/locale';

export default class LocalitiesAllDemo extends Component {
    constructor(props) {
        super(props);
        this.state = { usecase: 'localities' };
    }

    // eslint-disable-next-line class-methods-use-this
    renderSubHeader = () => (
        <p>
            {tr('You can select bewteen 2 use cases:')}
            <ul className="demo__desc__list">
                <li>{tr('Store Locator integration: autocomplete on city names, suburb names, postcodes...')}</li>
                <li>
                    {tr(
                        'Checkout integration: on full addresses, renders the right part of the address in the right form fields'
                    )}
                </li>
            </ul>
        </p>
    );

    renderUsecaseFilter = () => {
        const { usecase } = this.state;
        return {
            key: 'usecase',
            label: tr('Use case'),
            component: (
                <ButtonGroup isLight key="usecase">
                    <Button
                        type="group"
                        key="localities"
                        active={usecase === 'localities'}
                        onClick={() => {
                            this.setState({ usecase: 'localities' });
                        }}
                        label={tr('Store Locator')}
                    />
                    <Button
                        type="group"
                        key="addresses"
                        active={usecase === 'addresses'}
                        onClick={() => {
                            this.setState({ usecase: 'addresses' });
                        }}
                        label={tr('Checkout')}
                    />
                </ButtonGroup>
            ),
        };
    };

    render() {
        const { usecase } = this.state;
        const headerLabels = {
            title: tr('Localities API'),
            desc: tr(
                'Woosmap Localities sorts and displays the 5 most relevant results, with priority to the most likely results, recognises common abbreviations and apostrophes, with high tolerance for typos.'
            ),
        };
        return usecase === 'localities' ? (
            <LocalitiesDemo
                noheader={false}
                headerLabels={headerLabels}
                usecaseFilter={this.renderUsecaseFilter()}
                subHeader={this.renderSubHeader()}
            />
        ) : (
            <LocalitiesAddressDemo
                noheader={false}
                headerLabels={headerLabels}
                usecaseFilter={this.renderUsecaseFilter()}
                subHeader={this.renderSubHeader()}
            />
        );
    }
}
